const ABProcessTaskServiceInsertRecordCore = require("../../../core/process/tasks/ABProcessTaskServiceInsertRecordCore");
module.exports = class ABProcessTaskServiceInsertRecord extends (
   ABProcessTaskServiceInsertRecordCore
) {};
